/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsready2Inputs */

const en_ticketspayoutsready2 = /** @type {(inputs: Ticketspayoutsready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up with Stripe. Money is paid out two days after the event.`)
};

const de_ticketspayoutsready2 = /** @type {(inputs: Ticketspayoutsready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Stripe eingerichtet. Ausgezahlt wird zwei Tage nach dem Event.`)
};

/**
* | output |
* | --- |
* | "Set up with Stripe. Money is paid out two days after the event." |
*
* @param {Ticketspayoutsready2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsready2 = /** @type {((inputs?: Ticketspayoutsready2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsready2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsready2(inputs)
	return de_ticketspayoutsready2(inputs)
});
export { ticketspayoutsready2 as "ticketsPayoutsReady" }